
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { TableRow, TableCell, Checkbox, Avatar, Button, ListItemText, Table, Tooltip, MenuItem, IconButton } from "@mui/material";
import CustomPopover, {usePopover} from '../../../../components/custom-popover/index.js';
import Iconify from "../../../../components/iconify/iconify.js";
import Label from '../../../../components/label/index.js';
import { ConfirmDialog } from '../../../../components/custom-dialog/index.js';
import { useBoolean } from '../../../../hooks/use-boolean.js';
import { fDate } from '../../../../util/formatTime.js';
import { parseISO, format } from 'date-fns';

export default function AttendanceReportTableRow({row, selected, onSelected, onDeleteRow, onCancelledRow, onEditRow, onViewRow, onCompleted, onRevert, setAttritionRate}){
  const isRole = useSelector((state) => state?.auth?.isRole);
  const { courseRunId, course, classCode, courseDates, sessions, venue, venue_old, status, enrolment } =row;
  const venueDetails = venue?.block || venue?.postalCode ? `${venue?.block} ${venue?.street} #${venue?.floor}-${venue?.unit} ${venue?.room} ${venue?.building} ${venue?.postalCode}` : venue_old;
  const setTrainer = sessions.map(item => item?.trainer?.fullName)
  const filterTrainer = [...new Set(setTrainer)];

  const hrCourse = course?.ssgSupportedTrainingHours;


  // ATTRITION RATE
  const confirmedStartClass = enrolment.filter(item =>
    item?.ssgenrolment?.status === "Confirmed" ||
    (item?.ssgenrolment?.status === "Cancelled" && item?.isDropAfterClassStart)
  ).length;
  const cancelledEndClassEnd = enrolment.filter(item => 
    item?.ssgenrolment?.status === "Cancelled"  && !item?.isDropBeforeClassStart
  ).length;

 const attritionRateFunded = (cancelledEndClassEnd / confirmedStartClass) * 100;

 const traineeCount = enrolment?.length;
 const { eAttendanceCount, noAttendanceCount } = enrolment.reduce(
  (acc, item, index) => {
    const sessionIndex = sessions?.length - 1
    if (item?.eAttendance && !item?.eAttendance[sessionIndex]) {
      acc.eAttendanceCount += 1;
    } else {
      acc.noAttendanceCount += 1;
    }
    return acc;
  },
  { eAttendanceCount: 0, noAttendanceCount: 0 }
);
const attritionRateNonFunded = (eAttendanceCount / traineeCount) * 100;


const finalAttritionFunded = courseRunId && attritionRateFunded ? attritionRateFunded.toFixed(2) + '%' : attritionRateFunded === 0 ?  attritionRateFunded.toFixed(2) + '%' : 'NA';
const finalAttritionNonFunded = !courseRunId && attritionRateNonFunded ? attritionRateNonFunded.toFixed(2) + '%' : attritionRateNonFunded === 0 ? attritionRateNonFunded.toFixed(2) + '%' : "NA";


// Attendance Rate
// ISSUE course?.ssgSupportedAssessmentHours has been added
const totalHours = ((course?.ssgSupportedTrainingHours + course?.ssgSupportedAssessmentHours)  * enrolment.length);
const totalAttendanceHours = enrolment?.reduce((total, trainee) => {
  // Check if eAttendance exists and is an array before proceeding
  const traineeHours = Array.isArray(trainee.eAttendance) 
    ? trainee.eAttendance.reduce((acc, session) => {
        // Check if eSignature and its startTime and endTime properties exist
        if (!session?.eSignature?.startTime || !session?.eSignature?.endTime) {
          return acc; // Skip this session if start or end time is missing
        }
        const start = new Date(session.eSignature.startTime);
        const end = new Date(session.eSignature.endTime);
        const hours = (end - start) / (1000 * 60 * 60); // Convert milliseconds to hours
        return acc + hours;
      }, 0)
    : 0; // Default to 0 if eAttendance is not an array or is undefined
  return total + traineeHours;
}, 0);


const attendanceRate =  (totalAttendanceHours / totalHours) * 100

    const popover = usePopover();
    const confirm = useBoolean();
    const cancel = useBoolean();
    const completed = useBoolean();
    const revertBack = useBoolean();


 return (
    <>
    <TableRow hover selected={selected}>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{courseRunId}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{fDate(courseDates.start)}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{classCode}</TableCell>
            <TableCell>{course?.courseTitle}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{attendanceRate ? attendanceRate.toFixed(2) + '%' : 'NA'}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{courseRunId ? finalAttritionFunded : finalAttritionNonFunded}</TableCell>

            <TableCell align="right" sx={{px: 1, whiteSpace: 'nowrap'}}>
                    <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
            </TableCell>
    </TableRow>
    <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{width: 180}}
    >

        <MenuItem
          onClick={() => {
            setAttritionRate(courseRunId ? finalAttritionFunded : finalAttritionNonFunded)
            popover.onClose();
            onViewRow();
          }}
        >
        <Iconify icon="ic:round-print" />
            Print Attendance
        </MenuItem>

            


    </CustomPopover>

    <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content={`Are you sure want to delete ${classCode}?`}
        action={
          <Button variant="contained" color="error" onClick={() => {
            onDeleteRow();
            confirm.onFalse();
          }}>
            Delete
          </Button>
        }
      />

<ConfirmDialog
        open={cancel.value}
        onClose={cancel.onFalse}
        title="Cancel"
        content={`Are you sure want to cancel ${classCode}?`}
        action={
          <Button variant="contained" color="error" onClick={onCancelledRow}>
            Cancel
          </Button>
        }
      />

      <ConfirmDialog
        open={completed.value}
        onClose={completed.onFalse}
        title="Completed"
        content={`Are you sure want to update ${classCode} status to completed?`}
        action={
          <Button variant="contained" color="success" onClick={() => {
            onCompleted();
            completed.onFalse();
          }}>
            Yes
          </Button>
        }
      />

<ConfirmDialog
        open={revertBack.value}
        onClose={revertBack.onFalse}
        title="Revert Status"
        content={`Are you sure want to revert the  status to confirmed?`}
        action={
          <Button variant="contained" color="success" onClick={() => {
            onRevert();
            revertBack.onFalse();
          }}>
            Yes
          </Button>
        }
      />

</>
 )

}

AttendanceReportTableRow.propTypes = {
    onViewRow: PropTypes.func,
    onEditRow: PropTypes.func
  };
  
